import { useEffect } from "react";
import { QuickbooksCallbackViewModel } from "../../viewmodels/quickbooks/QuickbooksCallbackViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import EmptyModal from "../../components/modals/EmptyModal";
import type { AppDispatch, RootState } from "../../index";

interface QuickbooksCallbackScreenProps { logout: () => void }

function QuickbooksCallbackScreen(props: QuickbooksCallbackScreenProps) {
  const { logout } = props;
  const { emptyModal, setEmptyModelOpen, onStartCallback } = QuickbooksCallbackViewModel(logout);

  useEffect(() => {
    const search = typeof window !== "undefined" ? window.location.search : "";

    const searchParams = new URLSearchParams(search);
    const params = {
      code: searchParams.get("code"),
      state: searchParams.get("state"),
      realmId: searchParams.get("realmId"),
    };
    console.log("quickbooks callback params", params);
    // Pass parsed params (may be empty) to the viewmodel handler
    onStartCallback(params);
  }, []);

  return (
    <div>
      <div className="mt-2">hello quickbooks callback in progress</div>
      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
    </div>
  );
}

const mapStateToProps = (_state: RootState) => {
  return {};
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuickbooksCallbackScreen));
